import { OnlineBookingLastStep } from '@app/objects/OnlineBooking';

export const BOOKING = '/online-booking';
export const BOOKING_PHONE_VERIFICATION = `${BOOKING}/phone-verification`;
export const BOOKING_FAMILY = `${BOOKING}/family`;
export const BOOKING_PET = `${BOOKING}/pet`;
export const BOOKING_APPOINTMENT = `${BOOKING}/appointment`;
export const BOOKING_ARRANGEMENTS = `${BOOKING}/arrangements`;
export const BOOKING_SCHEDULE = `${BOOKING}/schedule`;
export const BOOKING_ADDITIONAL_INFORMATION = `${BOOKING}/additional-information`;
export const BOOKING_PAYMENT = `${BOOKING}/payment`;
export const BOOKING_CONFIRMATION = `${BOOKING}/confirmation`;

export const bookingRoutes: { [key: string]: string } = {
	[OnlineBookingLastStep.Family]: BOOKING_FAMILY,
	[OnlineBookingLastStep.Pet]: BOOKING_PET,
	[OnlineBookingLastStep.Appointment]: BOOKING_APPOINTMENT,
	[OnlineBookingLastStep.Arrangements]: BOOKING_ARRANGEMENTS,
	[OnlineBookingLastStep.Schedule]: BOOKING_SCHEDULE,
	[OnlineBookingLastStep.AdditionalInformation]: BOOKING_ADDITIONAL_INFORMATION,
	[OnlineBookingLastStep.Payment]: BOOKING_PAYMENT,
	[OnlineBookingLastStep.Confirmation]: BOOKING_CONFIRMATION,
};

export const LS_BOOKING = 'booking';
export const LS_FAMILY_STEP = 'familyStep';
export const LS_STEP_PET = 'stepPet';
export const LS_SCHEDULE_STEP = 'scheduleStep';
export const LS_SELECTED_OPTION = 'selectedOption';
export const LS_ERROR_CODE = 'errorCode';
export const LS_RESERVATION_START_TIME = 'reservationStartTime';
export const LS_CONTINUE_SESSION = 'continueSession';
export const LS_EXISTING_PET_ENTRY = 'existingPetEntry';
export const LS_ONLINE_BOOKING_TRACKING = 'onlineBookingTracking';
